/**
 * Lets a route (e.g. the Home tour) request that the app shell collapse its
 * sidebar, without lifting sidebar state out of AppBody.
 */
type CollapseListener = () => void;

let listeners: CollapseListener[] = [];

export function subscribeSideNavCollapse(listener: CollapseListener): () => void {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter((existing) => {return existing !== listener});
  };
}

export function requestSideNavCollapse(): void {
  listeners.forEach((listener) => {
    listener();
  });
}
